import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import UpcomingEventsSection from "@/components/profile/UpcomingEventsSection";
import GuestRegisterCard from "@/components/profile/GuestRegisterCard";

export default function EventsRegister() {
  const { user, personId, isLoading } = useAuth();
  const [searchParams] = useSearchParams();

  const rawEventId = searchParams.get("event_id");
  const eventId = rawEventId !== null ? Number(rawEventId) : null;
  const validEventId = eventId !== null && Number.isFinite(eventId);

  useEffect(() => {
    document.title = "Register for an event | Quizrun";
  }, []);

  return (
    <>
      <PageHeader
        eyebrow="Registration"
        title="Register for an event"
        intro="Secure your spot — solo or as a team."
      />

      <section className="pb-16">
        <div className="container mx-auto px-4 md:px-8">
          <div className="max-w-xl">
          {!validEventId ? (
            <p className="text-sm text-muted-foreground">
              No event selected.{" "}
              <Link
                to="/events"
                className="font-medium text-primary underline underline-offset-2"
              >
                Browse all events
              </Link>
              .
            </p>
          ) : !user ? (
            // Signed-out: public guest card (auth resolved, no session).
            !isLoading ? (
              <GuestRegisterCard eventId={eventId} />
            ) : (
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <Loader2 className="h-4 w-4 animate-spin" />
                Loading…
              </div>
            )
          ) : personId === null ? (
            // Signed-in but the person row is still resolving.
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Loader2 className="h-4 w-4 animate-spin" />
              Loading your account…
            </div>
          ) : (
            <UpcomingEventsSection
              personId={personId}
              variant="single"
              eventId={eventId}
            />
          )}
          </div>
        </div>
      </section>
    </>
  );
}
